import { createContext } from "react";
import axiosInstance from "../api/axios";

export const PlanContext = createContext();

async function addPlan(planData) {
  try {
    const res = await axiosInstance.post("/admin/plans", planData);
    return res;
  } catch (error) {
    throw error;
  }
}

async function getPlans() {
  try {
    const res = await axiosInstance.get("/admin/plans");
    // API returns: { status: "success", data: [...] }
    if (res.data) {
      // If response has status and data
      if (res.data.status === "success" && res.data.data) {
        return res.data;
      }
      // If data is directly an array
      if (Array.isArray(res.data)) {
        return { status: "success", data: res.data };
      }
      // If data.data exists
      if (res.data.data && Array.isArray(res.data.data)) {
        return res.data;
      }
    }
    return { status: "success", data: [] };
  } catch (error) {
    console.error("Error fetching plans:", error);
    throw error;
  }
}

async function getPlanById(id) {
  try {
    const res = await axiosInstance.get(`/admin/plans/${id}`);
    
    // Handle different response structures
    if (res.data) {
      // If response has status and data
      if (res.data.status === "success" && res.data.data) {
        return res.data.data.plan || res.data.data;
      }
      // If data.plan exists
      if (res.data.plan) {
        return res.data.plan;
      }
      // If data.data exists
      if (res.data.data) {
        return res.data.data;
      }
      // If data is the plan object directly
      if (res.data._id || res.data.name) {
        return res.data;
      }
    }
    
    throw new Error("Unexpected API response structure");
  } catch (error) {
    // Handle 404 specifically
    if (error.response?.status === 404) {
      const errorMsg = error.response?.data?.message || 
                       error.response?.data?.error || 
                       "Plan not found";
      const customError = new Error(errorMsg);
      customError.response = error.response;
      throw customError;
    }
    
    // Handle other errors
    if (error.response?.data) {
      const errorMsg = error.response.data.message || 
                       error.response.data.error || 
                       error.message;
      const customError = new Error(errorMsg);
      customError.response = error.response;
      throw customError;
    }
    
    // Re-throw the error so it can be handled by the component
    throw error;
  }
}

async function updatePlan(id, planData) {
  try {
    const res = await axiosInstance.put(`/admin/plans/${id}`, planData);
    return res;
  } catch (error) {
    throw error;
  }
}

function removePlan(id) {
  return axiosInstance
    .delete(`/admin/plans/${id}`)
    .then((response) => response)
    .catch((error) => {
      console.error("Error deleting plan:", error);
      throw error;
    });
}

export default function PlanContextProvider({ children }) {
  return (
    <PlanContext.Provider
      value={{
        addPlan,
        getPlans,
        getPlanById,
        updatePlan,
        removePlan,
      }}
    >
      {children}
    </PlanContext.Provider>
  );
}

